<template>
  <div class="distributor-box">
    <!--左边区域-->
    <div class="left_box" v-if="showLogistics">
      <div class="title_box">
        <h2 class="title">{{ $t('key1000220') }}</h2>
        <div class="option_btn" @click="switchBtn">
          <Icon size="18" type="ios-arrow-back"/>
        </div>
      </div>
      <div class="content_box">
        <Collapse v-model="enableModal" simple>
          <Panel name="1">
            <h2 class="collapse_title">{{ $t('key1002630') }}</h2>
            <div slot="content">
              <div class="collapse_item" v-for="item in enableData" :key="item.carrierId" :class="item.selected ?'slectActive' : ''">
                <div class="title" :title="item.carrierName" @click="changeLogisticsChanneBtn(item)">{{ item.carrierName }}</div>
                <div class="opt_btn" style="color: #FF0000;" v-if="getPermission('ymsCarrier_enable') || getPermission('ymsCarrier_disable')"
                  @click="logisticsEnableDisableBtn(item)">{{ $t('key1000463') }}
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
        <Collapse v-model="disableModal" simple class="mt10">
          <Panel name="1">
            <h2 class="collapse_title">{{ $t('key1006481') }}</h2>
            <div slot="content">
              <div class="collapse_item" v-for="item in disableData" :key="item.carrierId" :class="item.selected ?'slectActive' : ''">
                <div class="title" @click="changeLogisticsChanneBtn(item)">{{ item.carrierName }}</div>
                <div class="opt_btn" v-if="getPermission('ymsCarrier_enable') || getPermission('ymsCarrier_disable')"
                  @click="logisticsEnableDisableBtn(item)">{{ $t('key1000462') }}
                </div>
              </div>
            </div>
          </Panel>
        </Collapse>
      </div>
    </div>
    <!--右边区域-->
    <div class="right_box mb20" :style="showLogistics ? 'width: 77%' : 'width: 100%'">
      <div class="flex">
        <div class="option_btn mr10" @click="switchBtn" v-if="!showLogistics">
          <Icon size="18" type="ios-arrow-forward"/>
        </div>
        <!--功能按钮操作区域-->
        <div class="operation-box" v-if="tabName === 'logisticsAccount' && getPermission('ymsCarrierAccount_applyCarrierAuth') && showAccountAuthorization">
          <Button type="primary" @click="handleaccountAuthData">{{ $t('key1006460') }}</Button>
        </div>
      </div>
      <Tabs v-model="tabName" :animated="false" style="width: 100%" @on-click="changeTab">
        <TabPane :label="$t('key1000222')" name="logisticsChannel" v-if="getPermission('ymsCarrierShippingMethod_queryForEnableShippingMethods')">
          <div class="table-box">
            <Table
              ref="selection"
              highlight-row
              border
              max-height="630"
              :loading="tableLoading"
              :columns="logisticsChannelColumns"
              :data="logisticsChannelData">
            </Table>
          </div>
        </TabPane>
        <TabPane :label="$t('key1005418')" name="logisticsAccount" v-if="getPermission('ymsCarrierAccount_queryByCarrierId') && showAccountAuthorization">
          <div class="table-box">
            <Table
              ref="selection"
              highlight-row
              border
              max-height="630"
              :loading="tableLoading"
              :columns="logisticsAccountColumns"
              :data="logisticsAccountData">
            </Table>
          </div>
        </TabPane>
      </Tabs>
    </div>
    <!--物流渠道弹窗-->
    <ownLogisticsChannelModal ref="ownLogisticsChannel" @updateData="getLogisticsChannelList(carrierId)"></ownLogisticsChannelModal>
    <!--关联店铺弹窗-->
    <Modal v-model="affiliatedStoresModal" :title="$t('key1006468')" width="500"
      :transfer="false" :mask-closable="false" @on-visible-change="affiliatedStoresChange">
      <Form ref="affiliatedStoresModalForm" :model="affiliatedStoresModalForm" :label-width="100" @submit.native.prevent>
        <Row style="width: 80%;">
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1006480')" prop="platformStoreIds">
              <Select v-model="affiliatedStoresModalForm.platformStoreIds" transfer filterable multiple>
                <Option v-for="item in platformList" :key="item.authAccountId" :value="item.authAccountId">{{ item.accountName }}</Option>
              </Select>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <Button @click="affiliatedStoresModal = false">{{ $t('key1000112') }}</Button>
        <Button type="primary" @click="affiliatedStoresBtn">{{ $t('key1000111') }}</Button>
      </template>
    </Modal>
    <!--账户授权弹窗-->
    <authorizationInfoModal ref="authorizationInfo" @updateData="getLogisticsAccountList(carrierId)"></authorizationInfoModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import ownLogisticsChannelModal from "@/views/distributor/components/logisticsManage/ownLogisticsChannelModal";
import authorizationInfoModal from "@/views/distributor/components/logisticsManage/authorizationInfoModal";
import {_handleMultilingualFields, setConfigCharacters} from "@/utils/common";

export default {
  name: "ownLogistics",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      tabName: 'logisticsChannel',
      logisticsChannelColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002818'),
          key: 'carrierShippingMethodName',
          align: 'left',
          minWidth: 200,
          render(h, params) {
            let carrierShippingMethodName = params.row.carrierShippingMethodName;
            let name = _handleMultilingualFields(carrierShippingMethodName);
            return h('span', name);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006466'),
          key: 'carrierShippingMethodCode',
          align: 'left',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005212'),
          key: 'logisticsInterface',
          align: 'left',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'left',
          minWidth: 100,
          render(h, params) {
            let status = params.row.status;
            let text = status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : status === 0 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463') : status === 2 ? `${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002631')}` : '';
            return h('span', {class: status === 1 ? 'greenColor' : 'redColor'}, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000410'),
          key: 'efficiency',
          align: 'left',
          minWidth: 120,
          render: (h, params) => {
            let minEfficiency = params.row.minEfficiency;
            let maxEfficiency = params.row.maxEfficiency;
            let text = '';
            if (minEfficiency && !maxEfficiency) {
              text = minEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
            }
            if (maxEfficiency && !minEfficiency) {
              text = maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
            }
            if (minEfficiency && maxEfficiency) {
              text = minEfficiency + ' - ' + maxEfficiency + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001631');
            }
            return h('div', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003698'),
          key: 'code',
          align: 'left',
          minWidth: 120,
          render: (h, params) => {
            if (params.row.hasTrackingNumber) {
              return h('span', 'Y');
            } else {
              return h('span', 'N');
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 230,
          render: (h, params) => {
            let ststus = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsCarrierShippingMethod_detail'),
                    clickFn: () => {
                      v.$refs['ownLogisticsChannel'].ownLogisticsChannelFun(params.row.shippingMethodId, 'look');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000669'),
                    show: v.getPermission('ymsCarrierShippingMethod_update'),
                    clickFn: () => {
                      v.$refs['ownLogisticsChannel'].ownLogisticsChannelFun(params.row.shippingMethodId, 'edit');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: ststus !== 1 && v.getPermission('ymsCarrierShippingMethod_enable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row, 'enable');
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: ststus === 1 && v.getPermission('ymsCarrierShippingMethod_disable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row, 'disable');
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      logisticsChannelData: [],
      logisticsAccountColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001581'),
          key: 'carrierName',
          align: 'left',
          minWidth: 200
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001325'),
          key: 'account',
          align: 'left',
          minWidth: 120
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006467'),
          key: 'isOnline',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let isOnline = params.row.isOnline;
            let text = isOnline === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002255') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002256');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005821'),
          key: 'authStatus',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let authStatus = params.row.authStatus;
            let text = authStatus === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001326') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001327');
            let classColor = authStatus === 1 ? 'openStatus' : 'stopStatus';
            return h('div', {
              class: 'flex align-items-center'
            }, [
              h('span',
                {
                  class: `mr10 ${classColor}`
                }, text),
              h('Alink', {
                props: {
                  linkName: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005434'),
                  textAlign: 'left',
                  defineColor: '#02A7F0'
                },
                on: {
                  AlinkBtn: () => {
                    v.accountAuthorization(params.row);
                  }
                }
              })
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002157'),
          key: 'status',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let status = params.row.status;
            let text = status === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463');
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006468'),
          key: 'affiliatedStores',
          align: 'left',
          minWidth: 120,
          render(h, params) {
            let list = [];
            let carrierAccountAuthRelateds = params.row.carrierAccountAuthRelateds;
            if (carrierAccountAuthRelateds && carrierAccountAuthRelateds.length > 0) {
              carrierAccountAuthRelateds.map((item) => {
                list.push(item.platformName)
              })
            }
            return h('span', list.join('、'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'options',
          align: 'left',
          width: 180,
          render: (h, params) => {
            let status = params.row.status;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006468'),
                    show: true,
                    clickFn: () => {
                      v.getAffiliatedStoresList(params.row);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: status === 1 && v.getPermission('ymsCarrierAccount_disable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row, 'disable', params.row.account);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: status === 0 && v.getPermission('ymsCarrierAccount_enable'),
                    clickFn: () => {
                      v.enableDisableBtn(params.row, 'enable', params.row.account);
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      logisticsAccountData: [],
      enableModal: '1',
      disableModal: '1',
      showLogistics: true, // 默认展开物流商
      enableData: [], // 已启用的物流商数据
      disableData: [], // 未启用的物流商数据
      platformList: [],
      affiliatedStoresModal: false,
      affiliatedStoresModalForm: {
        platformStoreIds: []
      },
      carrierId: null,
      logisticsProviderInfo: {},
      carrierAccountId: null,
      selectCarrierCode: null,
    }
  },
  computed: {
    // 账户授权判断条件
    /**
     * 基础物流-线上物流：需要授权的仅“Wish邮”，其他线上物流均不需要授权；
     * 基础物流-线下物流：全部需要授权；
     * isOnline: 1 线上物流  0 线下物流
     */
    showAccountAuthorization() {
      const info = this.logisticsProviderInfo;
      return (info?.isOnline === 0 || (info?.isOnline === 1 && info?.carrierCode === 'wishu'));
    }
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await this.getLogisticsProviderData(true);
      })();
    },
    // 展开与收起物流商模块
    switchBtn() {
      this.showLogistics = !this.showLogistics;
    },
    // 获取物流商的数据
    getLogisticsProviderData(value) {
      let v = this;
      v.enableData = [];
      v.disableData = [];
      v.logisticsProviderInfo = {};
      v.axios.get(api.get_ymsCarrier_queryDistributorCarrier).then(response => {
        if (response.data.code === 0) {
          let newData = response.data.datas;
          if (newData && newData.length > 0) {
            let enableList = newData.filter((item) => {
              return item.distributorStatus === 1;
            });
            let disableList = newData.filter((item) => {
              return item.distributorStatus === 0;
            });
            if (value) {
              if (enableList.length > 0) {
                enableList[0].selected = true;
                v.carrierId = enableList[0].carrierId;
                v.logisticsProviderInfo = enableList[0];
              } else if (disableList.length > 0) {
                disableList[0].selected = true;
                v.carrierId = disableList[0].carrierId;
                v.logisticsProviderInfo = disableList[0];
              }
              if (v.getPermission('ymsCarrierShippingMethod_queryForEnableShippingMethods')) {
                v.tabName = 'logisticsChannel';
                v.getLogisticsChannelList(v.carrierId);
              } else if (v.getPermission('ymsCarrierAccount_queryByCarrierId')) {
                v.tabName = 'logisticsAccount';
                v.getLogisticsAccountList(v.carrierId);
              } else {
                v.gotoError()
              }
            } else {
              let arr = [...enableList, ...disableList];
              arr.map((item) => {
                item.selected = false;
                if (item.carrierId === v.carrierId) {
                  item.selected = true;
                  v.logisticsProviderInfo = item;
                }
              });
              enableList = arr.filter((item) => {
                return item.distributorStatus === 1;
              });
              disableList = arr.filter((item) => {
                return item.distributorStatus === 0;
              });
            }
            v.enableData = enableList;
            v.disableData = disableList;
          }
        }
      });
    },
    // 获取物流渠道列表数据
    getLogisticsChannelList(carrierId) {
      let v = this;
      v.logisticsChannelData = [];
      v.tableLoading = true;
      v.axios.get(api.get_ymsCarrierShippingMethod_queryForEnableShippingMethods + `?carrierId=${carrierId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          v.logisticsChannelData = data;
          v.$nextTick(() => {
            v.tableLoading = false;
          });
        }
      }).finally(() => {
        v.tableLoading = false;
      });
    },
    // 获取物流账户列表数据
    getLogisticsAccountList(carrierId) {
      let v = this;
      v.logisticsAccountData = [];
      v.axios.get(api.get_ymsCarrierAccount_queryByCarrierId + `${carrierId}`).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data && data.length > 0) {
            let carrierId = v.logisticsProviderInfo.carrierId;
            data.map((item) => {
              if (item.carrierId === carrierId) {
                item['isOnline'] = v.logisticsProviderInfo.isOnline;
                item['carrierName'] = v.logisticsProviderInfo.carrierName;
              }
            });
            v.logisticsAccountData = data;
          }
        }
      });
    },
    // 切换tab栏
    changeTab(name) {
      // 物流渠道
      if (name === 'logisticsChannel') {
        this.getLogisticsChannelList(this.carrierId);
      } else {
        this.getLogisticsAccountList(this.carrierId);
      }
    },
    // 选中物流商
    changeLogisticsChanneBtn(item) {
      let v = this;
      v.carrierId = item.carrierId;
      v.selectCarrierCode = item.carrierCode;
      v.logisticsProviderInfo = item;
      let data = [...v.disableData, ...v.enableData];
      data.map((ele, index) => {
        ele.selected = false;
        if (ele.carrierId === item.carrierId) {
          v.$set(data[index], 'selected', true);
        }
      });
      v.enableData = data.filter((item) => {
        return item.distributorStatus === 1;
      });
      v.disableData = data.filter((item) => {
        return item.distributorStatus === 0;
      });
      let talg = item.isOnline === 0 || (item.isOnline === 1 && item.carrierCode === 'wishu');
      if (!talg) {
        v.tabName = 'logisticsChannel';
      }
      if (v.tabName === 'logisticsChannel') {
        v.getLogisticsChannelList(item.carrierId)
      } else {
        v.getLogisticsAccountList(item.carrierId);
      }
    },
    // 物流商的启用、停用
    logisticsEnableDisableBtn(data) {
      let v = this;
      let distributorStatus = data.distributorStatus === 1;
      v.selectCarrierCode = data.carrierCode;
      // 停用
      if (distributorStatus) {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006469'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006470'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            v.axios.put(api.put_ymsCarrier_disable + `${data.carrierId}`, null,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                v.getLogisticsProviderData(false);
              }
            });
          },
          onCancel: () => {
          }
        });
      }
      // 启用
      else {
        v.$Modal.confirm({
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006471'),
          content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006472'),
          okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
          cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
          onOk: () => {
            let query = {
              carrierId: data.carrierId,
              systemCarrierId: data.systemCarrierId
            };
            v.axios.put(api.put_ymsCarrier_enable, query,
              {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
              if (response.data.code === 0) {
                v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
                v.getLogisticsProviderData(false);
              }
            });
          },
          onCancel: () => {
          }
        });
      }
    },
    // 物流渠道、物流账户的启用、停用按钮
    enableDisableBtn(data, type, accountName) {
      let v = this;
      // 启用
      if (type === 'enable') {
        // 物流渠道
        if (v.tabName === 'logisticsChannel') {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006473'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006474'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              let query = {
                carrierId: data.carrierId,
                shippingMethodEnableDetails: [
                  {
                    shippingMethodId: data.shippingMethodId,
                    systemShippingMethodId: data.systemShippingMethodId,
                    coreShippingMethodId: data.coreShippingMethodId,
                  }
                ]
              };
              v.axios.put(api.put_ymsCarrierShippingMethod_enable, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                  v.getLogisticsChannelList(data.carrierId);
                }
              });
            },
            onCancel: () => {
            }
          });
        }
        // 物流账户
        else {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006475'),
            content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006462')}${accountName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006463')}`,
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              v.axios.put(api.put_ymsCarrierAccount_enable + data.carrierAccountId, null,
                {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                  v.getLogisticsAccountList(data.carrierId);
                }
              });
            },
            onCancel: () => {
            }
          });
        }
      }
      // 停用
      else {
        // 物流渠道
        if (v.tabName === 'logisticsChannel') {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006476'),
            content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006477'),
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              v.axios.get(api.get_ymsCarrierShippingMethod_disable + data.shippingMethodId, null,
                {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                  v.getLogisticsChannelList(data.carrierId);
                }
              });
            },
            onCancel: () => {
            }
          });
        }
        // 物流账户
        else {
          v.$Modal.confirm({
            title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006478'),
            content: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006464')}${accountName}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006465')}`,
            okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
            cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
            onOk: () => {
              v.axios.put(api.put_ymsCarrierAccount_disable + data.carrierAccountId, null,
                {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                if (response.data.code === 0) {
                  v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000155'));
                  v.getLogisticsAccountList(data.carrierId);
                }
              });
            },
            onCancel: () => {
            }
          });
        }
      }
    },
    // 获取对应平台关联店铺的数据
    getAffiliatedStoresList(data) {
      let v = this;
      v.platformList = [];
      v.affiliatedStoresModalForm.platformStoreIds = [];
      v.carrierAccountId = data.carrierAccountId;
      let extendJson = this.logisticsProviderInfo.extendJson;
      let list = [];
      if (extendJson) {
        list = (JSON.parse(extendJson));
      }
      v.axios.get(api.get_ymsPlatformAccount_queryAuthAccountList + `?platformId=${list[0]}`).then(response => {
        if (response.data.code === 0) {
          let newList = response.data.datas;
          v.affiliatedStoresModal = true;
          if (newList && newList.length > 0) {
            let carrierAccountAuthRelateds = data.carrierAccountAuthRelateds;
            if (carrierAccountAuthRelateds) {
              v.affiliatedStoresModalForm.platformStoreIds = carrierAccountAuthRelateds.map((item) => {
                return item.thirdAuthAccountId
              });
            }
            v.platformList = newList;
          }
        }
      });
    },
    // 关联店铺的确定按钮
    affiliatedStoresBtn() {
      let v = this;
      let query = {
        authAccountIds: v.affiliatedStoresModalForm.platformStoreIds,
        carrierAccountId: v.carrierAccountId
      };
      v.axios.put(api.put_ymsCarrierAccount_saveAccountRelated, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.affiliatedStoresModal = false;
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
          v.getLogisticsAccountList(v.carrierId);
        }
      });
    },
    // 监听关联店铺弹窗
    affiliatedStoresChange(value) {
      if (!value) {
        this.$refs['affiliatedStoresModalForm'].resetFields();
      }
    },
    // 处理账户授权数据
    handleaccountAuthData() {
      let v = this;
      v.axios.get(api.get_carrierAccount_getCarrierAccount + v.carrierId).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data) {
            let name = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1006479') + (v.logisticsAccountData.length > 0 ? v.logisticsAccountData.length + 1 : 1);
            data.account = name;
            data.status = 1;
            data.authStatus = 1;
            // authType: 物流商授权方式,01/token、用户密码授权;02/oAuth授权;  03/客户直接填写授权信息
            // 走三方授权
            if (data.authType === '02') {
              this.accountAuthorization();
            }
            // 走本地授权
            else {
              v.$refs['authorizationInfo'].handleAuthData(data);
            }
          }
        }
      });
    },
    // 账户授权
    accountAuthorization(data) {
      // let extendJson = this.logisticsProviderInfo.extendJson;
      // let list = [];
      // if (extendJson) {
      //   list = (JSON.parse(extendJson));
      // }
      let carrierCode = null;
      if (data) {
        this.carrierAccountId = data.carrierAccountId;
      }
      if (this.selectCarrierCode === 'wishu') {
        carrierCode = 'wishpost'
        this.authorizedOperation(carrierCode);
      } else {
        carrierCode = this.selectCarrierCode;
        this.authorizedOperation(carrierCode);
      }
    },
    // 新增、编辑店铺需要调申请授权接口重定向到三方授权系统进行操作
    authorizedOperation(platformId, ymsPlatformAccountId = null, authType = '', action = 'edit') {
      let v = this;
      v.axios.post(api.post_ymsCarrierAccount_applyCarrierAuth, {
        "action": action, // 行动(toauth(返回授权地址)、edit(返回表单地址))
        "ymsPlatformAccountId": ymsPlatformAccountId, // 授权账号TOKEN流水号
        "currentAuthType": authType,
        "platformId": platformId,
        carrierId: v.logisticsProviderInfo.carrierId,
        carrierAccountId: v.carrierAccountId
      }).then(res => {
        if (res.data.code === 0) {
          let data = res.data.datas;
          if (data) {
            window.open(data.redirectUrl, '_blank');
          } else {
            v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1005425'));
            return false;
          }
        }
      });
    },
  },
  components: {
    ownLogisticsChannelModal,
    authorizationInfoModal
  }
}
</script>

<style lang="less" scoped>
.distributor-box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .left_box {
    width: 300px;
    margin-right: 20px;
    background-color: #fff;
    border-radius: 2px;
    overflow-y: auto;
    max-height: 650px;

    .title_box {
      height: 37px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      border-bottom: 1px solid #dcdee2;
      padding-left: 12px;
      position: sticky;
      left: 0;
      top: 0;
      z-index: 10;
      background-color: #fff;

      .title {
        font-size: 15px;
        font-weight: bold;
        color: #333;
      }
    }

    .content_box {
      padding: 5px 12px;

      /deep/ .ivu-collapse {
        border: none;

        .ivu-collapse-header {
          display: flex;
          align-items: center;
          padding: 0;
          line-height: initial;
          height: 25px;

          .ivu-icon {
            margin: 0 6px 0 0;
          }

          .collapse_title {
            font-size: 14px;
            color: #000;
            font-weight: bold;
          }
        }

        .ivu-collapse-content-box {
          padding: 0;
        }

        .ivu-collapse-content {
          padding: 0;

          .collapse_item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 30px;

            .title {
              display: inline-block;
              width: 220px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              color: #333;
              font-size: 13px;
              cursor: pointer;
              padding-left: 25px;
            }

            .opt_btn {
              font-size: 13px;
              cursor: pointer;
              color: #FD5425;
              padding-right: 5px;
            }
          }

          .slectActive {
            background-color: #fff6f0;
          }
        }
      }
    }
  }

  .right_box {
    flex: 1;
    overflow: hidden;
  }

  .option_btn {
    background-color: #FD5425;
    color: #fff;
    height: 37px;
    width: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
}
</style>